import { connect } from 'react-redux';
import AvatarModal from '../../components/AvatarModal';

import { toggleModal } from '../slices/modalSlice';
import { availabilityToggle } from '../slices/availabilityModalSlice';
import { logout } from '../slices/userSlice';

const mapState = (state) => ({
  isModalOpen: state.modal.isModalOpen,
  isConnected: state.user.isConnected,
  informations: state.user.informations,
});

const mapDispatch = (dispatch) => ({
  toggleModal: () => {
    const action = toggleModal();
    dispatch(action);
  },
  availabilityToggle: () => {
    const action = availabilityToggle();
    dispatch(action);
  },
  logout: () => {
    const action = logout();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(AvatarModal);
